import {
    setSubscriptionToDetails, setSubscriptionToQuote,
    updateSuperStarInstrumentsToBackend, updateTickerSubscriptionWithKite
} from "../../../../services/apiService";  // Adjust the path according to your file structure

export const handleShowDetails = (instrumentToken, SuperStarInstruments, setSuperStarInstruments, setLayouts, tabID,itemIndex,moreDetailsLayoutRef) => {
    /*console.log("handleShowDetails");*/
    // Find the index of the clicked item
    const clickedIndex = SuperStarInstruments.findIndex(instrument => instrument.instrumentEntity.instrumentToken === instrumentToken);

    // Update the content of the clicked instrument with additional data

        const clickedInstrument = SuperStarInstruments[clickedIndex];
    /*console.log("handleShowDetails11111");*/

        // Toggle logic: If the item already has additional data, remove it; otherwise, add the grid layout
        if (clickedInstrument.isDetailsVisible) {
            /*console.log("handleShowDetails2222222");*/
            /*delete clickedInstrument.moreDetails;  // Remove the additional data*/
            clickedInstrument.isDetailsVisible = false;  // Mark details as hidden
            setSubscriptionToQuote(instrumentToken,"tabID:" +tabID);
            setLayouts((prevLayouts) => {
                const updatedLayouts = prevLayouts.map((item, index) =>
                    index === itemIndex
                        ? { ...item, h: 1 } // Update the height dynamically
                        : item
                );
                /*console.log("22222Updated layout with dynamic height:", updatedLayouts);*/
                return updatedLayouts;
            });
        } else {
            setSubscriptionToDetails(instrumentToken,"tabID:"+tabID);
            /*clickedInstrument.moreDetails = (
                <MoreDetailsLayout ref={moreDetailsLayoutRef} setLayouts={setLayouts} itemIndexToShowDetailsOf={itemIndex}/>
            );*/
            setLayouts((prevLayouts) => {
                const updatedLayouts = prevLayouts.map((item, index) =>
                    index === itemIndex
                        ? { ...item, h: 10.4 } // Update the height dynamically
                        : item
                );
                /*console.log("22222Updated layout with dynamic height:", updatedLayouts);*/
                return updatedLayouts;
            });
            setSuperStarInstruments([...SuperStarInstruments]);  // Update the SuperStarInstruments array to trigger re-render
            clickedInstrument.isDetailsVisible = true;  // Mark details as visible
            setSuperStarInstruments([...SuperStarInstruments]);  // Update the SuperStarInstruments array to trigger re-render
        }
    setSuperStarInstruments([...SuperStarInstruments]);  // Update the SuperStarInstruments array to trigger re-render
};


// Utility function to generate random sentences
export const generateRandomSentence = () => {
    const sentences = [
        "This is a random sentence.",
        "Another small random sentence.",
        "Here's some random text.",
        "Randomness at its best.",
        "Simple and short.",
        "Generated text for demo.",
        "Smooth and simple writing.",
        "Text to fill the space.",
        "Another random line here.",
        "Last but not least."
    ];
    return sentences[Math.floor(Math.random() * sentences.length)];
};